import { Button, Col, Divider, Input, Modal, Result, Row, Select, Skeleton, Spin } from 'antd';
import API from 'API';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import debounce from 'lodash/debounce';
import toastr from 'toastr';
import FullMask from 'components/layout/FullMask';
import { normalize } from 'general_function';

export default function EnrollStudent({ course, setCourses, term }) {
    const [assignedStudents, setAssginedStudents] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [pageMask, setPageMask] = useState(false);
    const [invalidStudents, setInvalidStudents] = useState([]);
    const [searchAssignedStudent, setSearchAssignedStudent] = useState("");
    useEffect(() => {
        if (!term) {
            setAssginedStudents([]);
        }
        async function getData() {
            setLoading(true);
            try {
                const response = await API.post("/enroll-student-course/", {
                    course_id: course.id, term_id: term.id
                })
                setAssginedStudents(response.data.map(item => ({
                    label: `${item.last_name.trim()} ${item.first_name.trim()} - (MSSV: ${item.student_number})`,
                    value: item.id,
                })));
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }
        getData();
        // eslint-disable-next-line
    }, [course.id, term?.id])

    const debounceSearch = useMemo(() =>
        debounce(async (value) => {
            if (!value) return;
            setFetching(true);

            try {
                const response = await API.get(`/students?search=${value}`);
                setOptions(response.data.results.map((item) => ({
                    label: `${item.last_name.trim()} ${item.first_name.trim()} - (MSSV: ${item.student_number})`,
                    value: item.id,
                })));
            } catch (e) {
                console.error(e);
            } finally {
                setFetching(false);
            }
        }, 300
        ), []);


    const handleSearch = useCallback((value) => {
        debounceSearch(value)
    }, [debounceSearch])

    const enrollStudent = useCallback(async () => {
        setPageMask(true);
        try {
            const response = await API.post("/enroll-student-course/", {
                course_id: course.id, term_id: term.id, students: selectedStudents.map(item => item.value)
            })
            setAssginedStudents(assignedStudents => [...selectedStudents.filter(item=>!response.data.find(item2=>item2.id === item.value)), ...assignedStudents])
            setCourses(courses => {
                const index = courses.results.findIndex(item => course.id === item.id);
                course.numbers_of_students += selectedStudents.length;
                courses.results[index] = { ...course }
                return { ...courses, results: [...courses.results] }
            })
            setSelectedStudents([]);
            setInvalidStudents(response.data.map(item => ({
                label: `${item.last_name.trim()} ${item.first_name.trim()} - (MSSV: ${item.student_number})`,
                value: item.id,
            })))
        } catch (e) {
            if (e?.response?.status === 400 && e?.response?.data?.error === "Term is expired") {
                toastr.error("Kỳ này đã kết thúc! Không thể đăng ký thêm sinh viên!");
                return;
            }
            console.log(e);
        } finally {
            setPageMask(false);
        }
    }, [selectedStudents, course, term, setCourses])

    const searchedAssignedStudents = useMemo(() => assignedStudents.filter(
        item => normalize(item.label).includes(normalize(searchAssignedStudent))
    ), [assignedStudents, searchAssignedStudent])

    return loading ? <Skeleton active /> : <div style={{ position: "relative" }}>
        {pageMask && <FullMask page />}
        <Row gutter={8}>
            <Col span={12}>
                <Divider>
                    Đăng ký sinh viên
                </Divider>
                <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    showSearch
                    labelInValue
                    filterOption={false}
                    onSearch={handleSearch}
                    notFoundContent={fetching ? <Spin size="small" /> : null}
                    placeholder="Tìm sinh viên"
                    options={options}
                    value={selectedStudents}
                    onChange={(v) => {
                        if (v.length > 0) {
                            const find = assignedStudents.find(item => item.value === v[v.length - 1].value)
                            if (find) {
                                toastr.error(`Sinh viên ${find.label} đã được đăng ký vào môn học ${course.name}!`, "Lưu ý")
                                return;
                            }
                        }
                        setSelectedStudents(v);
                    }}
                />
                <Button type='primary' onClick={enrollStudent}
                    style={{ marginTop: 5 }} disabled={selectedStudents.length === 0}>
                    Đăng ký
                </Button>
            </Col>
            <Col span={12}>
                <Divider>
                    Sinh viên đã đăng ký
                </Divider>
                <Input.Search
                    value={searchAssignedStudent}
                    onChange={e => setSearchAssignedStudent(e.target.value)}
                    placeholder='Tìm sinh viên'
                />
                <div className="students-div" style={{ marginTop: 5 }}>
                    {searchedAssignedStudents.map(item => <div key={item.value}>{item.label}</div>)}
                </div>
            </Col>
        </Row>
        <Modal
            open={invalidStudents.length}
            onClose={() => setInvalidStudents([])}
            footer={[
                <Button key="close" type='primary' onClick={() => setInvalidStudents([])}>
                    Đóng
                </Button>
            ]}
        >
            <Result status="error">
                <div style={{ textAlign: "center" }}>
                    Danh sách sinh viên sau không đủ điều kiện đăng ký môn học <b>{course.name}</b><br />
                    (chưa học môn tiên quyết)
                    <div className="students-div">
                        {invalidStudents.map(item => <div key={item.value}>{item.label}</div>)}
                    </div>
                </div>
            </Result>
        </Modal>
    </div>
}
